define([
	"dojo/_base/declare",
	"dojo/topic",
	"csi/_base/underscore",
	"csi/datasheet/Widget",
	"csi/xml"
], function(declare,topic,_,DataSheetWidget,xml) {

	var PROPERTIES = {
		"Colors": "bomAvailableColorUrls",
		"Sizes": "bomAvailableSizeUrls",
		"QuoteProductAlternative": "activeProductAlternative"
	};

	return declare(DataSheetWidget, {
		_supplierItemHandle: null,
		_supplierItemPlacements: null,

		onInsertViewParams: function(/*View*/defView, /*Node*/node, /*Object*/params) {
			// summary: preset active colors for PartMaterials view if quote has colors
			var rev = this.getViewNode();
			var viewId = defView.getId();

			if (viewId == "PartMaterials") {
            	if (rev.Colors.length) {
	            	params[PROPERTIES.Colors] = _.clone(rev.Colors);
	            }
            	if (rev.ProductSizes.length) {
            		params[PROPERTIES.Sizes] = _.clone(rev.ProductSizes);
            	}
			}

			if ((viewId == "Items") || (viewId == "PartMaterials")) {
	            if (xml.isValidURL(rev.QuoteProductAlternative)) {
	            	params[PROPERTIES.QuoteProductAlternative] = rev.QuoteProductAlternative;
	            }
			}

			this.inherited(arguments);
		},

		onViewStart: function(/*Deferred[]*/dfds) {
			// summary: watch for changes to colors and product alternative
			this._supplierItemHandle = this._supplierItemHandle || topic.subscribe("/csi/attribute/change", _.bind(this._supplierItemChangeAttribute, this));
			this.inherited(arguments);
		},

		uninitialize: function() {
			// summary: remove topic handle
		    if (this._supplierItemHandle)
		        this._supplierItemHandle.remove();
			this.inherited(arguments);
		},

		_supplierItemChangeAttribute: function(/*Node*/node, /*String*/id, /*Any*/oldValue, /*Any*/newValue) {
			// summary: update appropriate views if colors or alternative changes, but only apply new value
			// if view's value was still the same as the old value
			var prop = PROPERTIES[id];
			if (prop && (node.$URL == this.urlRoot)) {
				_.each(["Items","PartMaterials"], function(viewId) {
					var view = this.getChildView(viewId);

					if (view && _.isEqual(view.get(prop), oldValue)) {
						view.set(prop, newValue);
						view.refreshWidget();
					}
				}, this);
			}
		}
	});
});
